import React, { ReactNode } from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { StickyCtaBar } from '../../components/StickyCtaBar';
import CustomizerLayoutSidePanel from '../../components/CustomizerLayoutSidePanel';

export const CardFrontConfigPanel = ({
  hideStickyCtaBar,
  renderCustomizations,
  onNext,
  allowOrderEdit,
  nextStepLabel = 'Edit Back',
}: {
  hideStickyCtaBar: boolean;
  renderCustomizations: () => ReactNode;
  onNext: () => void;
  allowOrderEdit?: boolean;
  nextStepLabel?: string;
}) => {
  return (
    <CustomizerLayoutSidePanel
      title="Edit Front"
      withBlur={hideStickyCtaBar}
      allowOrderEdit={allowOrderEdit}
    >
      {renderCustomizations()}
      {!hideStickyCtaBar && (
        <StickyCtaBar>
          <ButtonV2
            fullWidth={true}
            intent="neutral"
            shape="rounded"
            onClick={onNext}
          >
            Next: {nextStepLabel}
          </ButtonV2>
        </StickyCtaBar>
      )}
    </CustomizerLayoutSidePanel>
  );
};
